var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.606 36.364c-1.149 0-2.233-.15-3.253-.448a9.39 9.39 0 0 1-2.85-1.392c-.879-.63-1.582-1.514-2.11-2.651-.527-1.138-.791-2.47-.791-3.994 0-.707.187-1.376.563-2.006a7.083 7.083 0 0 1 1.407-1.69 41.518 41.518 0 0 1 1.723-1.442 17.793 17.793 0 0 0 1.688-1.524c.54-.553.915-1.105 1.126-1.657-2.65.353-4.772 1.292-6.367 2.817-1.594 1.524-2.391 3.646-2.391 6.364 0 1.966.351 3.8 1.055 5.501h-4.89a21.626 21.626 0 0 1-.667-5.369c0-2.696.533-5.038 1.6-7.027 1.067-1.988 2.526-3.546 4.379-4.673a64.43 64.43 0 0 1-1.301-1.127 24.036 24.036 0 0 1-3.553-4.11l3.447-3.148c.774 1.613 1.9 3.093 3.377 4.441.727.663 1.436 1.133 2.128 1.409.691.276 1.495.436 2.409.48-.235-.353-.704-.933-1.407-1.74-.703-.806-1.225-1.552-1.565-2.237-.34-.685-.51-1.47-.51-2.353a4.89 4.89 0 0 1 .826-2.768 6.309 6.309 0 0 1 2.164-2.005c.89-.508 1.858-.9 2.901-1.177a12.124 12.124 0 0 1 3.113-.414c1.853 0 3.605.392 5.259 1.177a13.106 13.106 0 0 1 4.29 3.248c1.208 1.38 2.17 3.066 2.885 5.054.715 1.989 1.073 4.132 1.073 6.43 0 2.276-.475 4.53-1.425 6.762-.95 2.231-2.169 4.16-3.658 5.783A19.055 19.055 0 0 1 26.2 34.84c-1.9 1.016-3.764 1.525-5.593 1.525z",
    fill: "#54585A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.849 2.424)",
    d: "M0 0h31.515v33.939H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyIcon);
export default __webpack_public_path__ + "static/media/kidneyIcon.76dd6dbd.svg";
export { ForwardRef as ReactComponent };